export default __webpack_public_path__ + "static/media/lento_logo_transparent.2a1ef4d7.png";